<template>
    <b-container fluid>
        <b-row>
            <b-col lg="6" class="my-1">    
            <b-form-group
                  label="Filtrar"
                  label-cols-sm="3"
                  label-align-sm="right"
                  label-size="sm"
                  label-for="filterInput"
                  class="mb-0"
            >
                <b-input-group size="sm">
                    <b-form-input
                      v-model="filter"
                      type="search"
                      id="filterInput"
                      placeholder="Escriba para filtrar"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                    </b-input-group-append>
                </b-input-group>
            </b-form-group>
            </b-col>

            <b-col sm="5" md="6" class="my-1">
                <b-form-group
                  label="Por página"
                  label-cols-sm="6"
                  label-cols-md="6"
                  label-cols-lg="3"
                  label-align-sm="right"
                  label-size="sm"
                  label-for="perPageSelect"
                  class="mb-0"
                >
                  <b-form-select
                    v-model="perPage"
                    id="perPageSelect"
                    size="sm"
                    :options="pageOptions"
                  ></b-form-select>
            </b-form-group>
            </b-col>
        </b-row>
        <b-table 
            striped hover 
            responsive
            small
            :sticky-header="maxWidth(windowWidth)"

            :items="items" 
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"

            :filter="filter"
            :filterIncludedFields="filterOn"
            @filtered="onFiltered"

            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"

            >
           
           <template v-slot:cell(url)="row">
            
            <b-form-checkbox v-model="row.detailsShowing" @change="row.toggleDetails">
                ver detalles
            </b-form-checkbox>
            </template>
            <template v-slot:row-details="row">
                <b-card>
                    <ul v-for="(url, key) in urls" :key="key"><!--row.item -->
                        <li v-if=" url.idsolicitud == row.item.id" >
                   
                            <b-link :href="url.link" target="_blank">{{url.link}}</b-link>
                        </li>
                    </ul>
                </b-card>
            </template>
            <template v-slot:cell(comentario_ingenieria)="row">
                 <ul v-for="(comentario, key) in comentarios" :key="key"><!--row.item -->
                        <li v-if=" comentario.salesid == row.item.id" >
                   
                            {{comentario.comentario}}
                        </li>
                    </ul>
            </template>


        </b-table>
       
        <!-- Paginacion -->
        <b-pagination
                  v-model="currentPage"
                  :total-rows="items.length"
                  :per-page="perPage"
                  align="center" 
                  
                  class="my-0"
                >
        </b-pagination>
    </b-container>
</template>

<script>
    import {mapActions,mapMutations,mapState} from 'vuex'
    import validateMixin from '@/mixins/validation' //para usar el mixin de vee-validate
    import customMixin from '@/mixins/customMixin'
    export default {
        components:{
            //userForm
        },  
        mixins : [validateMixin,customMixin],
        props:{
            items:{
                type: Array,
                required: true
            },
            fields:{
                type: Array,
                required:true
            },
            urls:{
                type: Array,
                required: true
            },
            comentarios:{
                type: Array,
                required: true    
            }
        },
        data:function(){
            return{
                currentPage: 1,
                perPage: 10,
                pageOptions: [10, 50, 100],
                sortBy: '',
                sortDesc: false,
                sortDirection: 'asc',

                infoModal: {
                    id: 'info-modal',
                    title: '',
                    comentario: ''
                },
                id:'',
                commentState: null,
                filter:'',
                filterOn: [],
                totalRows: 1,
                item:[],
               
            }
               
        },
        
        computed:{
            ...mapState(['windowWidth']),//llamamos al estado.
             
        },
        
        methods:{
            ...mapActions({
                _cerrar: 'ingenieria/cerrarOrden',
                _ordenar: 'ingenieria/guardarOrdenar'
            }),
            
            /**
             * Metodo que verifica si una orden esta cerrada y deshabilita el boton.
             */
            isDisabled(newVal){
                    if (newVal.status === "Cerrada"){
                        return this.disable = true
                    }
                
            },
            orden(item){
                let payload
                payload = {
                    'id': item.id,
                    'orden': item.orden
                }
                this._ordenar(payload).then(() => {
                    console.log('actualizado')
                })
             
            },
            cerrar(item, index, button){
                this.infoModal.title = `Orden #: ${item.id}`
                this.item = item
                this.$root.$emit('bv::show::modal', this.infoModal.id, button)
            },
            
            handleSubmit() {
               let payload
               // si no es valido sale de la funcion
               if (!this.checkFormValidity()) {
                 return
               }
               
               //   this.submittedNames.push(this.name)
                payload =
                    {'id':  this.item.id, 
                    'comentario' : this.infoModal.comentario
                    }
                    this._cerrar(payload).then(() =>{
                         this.$bvModal.hide('info-modal')
                    })

               // Hide the modal manually
              /* this.$nextTick(() => {
                
               })*/
            },
            resetModal() {
               this.infoModal.comentario = ''
               
            },
            handleOk(bvModalEvt) {

              // Prevent modal from closing
              bvModalEvt.preventDefault()
              // Trigger submit handler
              this.handleSubmit()
            },
            checkFormValidity() {
                const valid = this.$refs.form.checkValidity()
                this.commentState = valid
                return valid
            },
            onFiltered(filteredItems) {
                this.totalRows = filteredItems.length
                this.currentPage = 1
            }
        }//methods
        
    }//export
</script>

<style lang="scss" scoped>

</style>